var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVgc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 176,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(\"https://fonts.googleapis.com/css2?family=Nunito\")"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 442,
    height: 178,
    id: "canvas_background",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "canvasGrid",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    width: 456,
    height: 279,
    x: 1,
    y: 1,
    strokeWidth: 0,
    fill: "url(#gridpattern)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#1c3144",
    stroke: "#000",
    strokeWidth: 0,
    x: 5.21875,
    y: 128.75,
    id: "svg_2",
    fontSize: 124,
    fontFamily: "Nunito, Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    fill: "#1c3144",
    stroke: "#000",
    strokeWidth: 0,
    x: 76.21875,
    y: 130.75,
    id: "svg_3",
    fontSize: 62,
    fontFamily: "Nunito, Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "ERY"), /*#__PURE__*/React.createElement("text", {
    fill: "#1c3144",
    strokeWidth: 0,
    x: 179.21875,
    y: 159.75,
    id: "svg_6",
    fontSize: 31,
    fontFamily: "'Courier New', Courier, monospace",
    textAnchor: "start",
    xmlSpace: "preserve",
    stroke: "#000"
  }, "&lt;Coding Co./&gt;"), /*#__PURE__*/React.createElement("text", {
    fill: "#1c3144",
    stroke: "#000",
    strokeWidth: 0,
    x: 202.21875,
    y: 128.75,
    id: "svg_7",
    fontSize: 124,
    fontFamily: "Nunito, Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    fill: "#1c3144",
    stroke: "#000",
    strokeWidth: 0,
    x: 294.21875,
    y: 130.75,
    id: "svg_8",
    fontSize: 62,
    fontFamily: "Nunito, Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "OOD")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgc);
export default __webpack_public_path__ + "static/media/vgc.fa10b304374015ee686010d5b08b900e.svg";
export { ForwardRef as ReactComponent };